import React, { createContext, useEffect, useState } from 'react';

export const ComponentContext = createContext();

const ComponentProvider = props => {

  const [currentNavState, setCurrentNavState] = useState(['root'])

  return (
    // this is the provider providing state
    <ComponentContext.Provider value={{
      currentNavState: [currentNavState, setCurrentNavState]
    }}>
      {props.children}
    </ComponentContext.Provider>
  );
}

export default ComponentProvider